module.exports = __webpack_public_path__ + "html/stellantis-website.template.html";